import PropTypes from "prop-types"
import React from "react"

const NumberedCircle = ({ number, className = "" }) => {
  return (
    <div
      className={`flex size-6 items-center justify-center rounded-full bg-gray-700 text-sm font-bold text-white ${className}`}
    >
      {number}
    </div>
  )
}

NumberedCircle.propTypes = {
  number: PropTypes.number.isRequired,
  className: PropTypes.string,
}

export default NumberedCircle
